import { LandingHero, LandingHeroProps } from '../../../../components/_external-pages/landing';

const props: LandingHeroProps = {
  title: '¡Alcanzar tu sueño es posible!',
  subtitle: 'Tu vivienda o negocio pueden ayudarte a conseguirlo.',
  text: 'Préstamos con garantía  hipotecaria, 100% en línea.',
  image: '/static/home/hero.webp',
  overlay: '/static/overlay.svg',
  buttons: [
    {
      text: 'Solicita tu crédito',
      href:
        process.env.REACT_APP_APP_IBAN_ONLINE || 'http://dev.app.ibanonline.com.mx/online/register',
      variant: 'contained',
      to: '',
      size: 'medium',
      color: 'primary'
    },
    {
      text: 'Simula tu crédito',
      to: 'simulador',
      variant: 'contained',
      size: 'medium',
      color: 'inherit',
      href: ''
    }
  ]
};

export const HomeHero = () => {
  return <LandingHero {...props} />;
};
